import jwtDecode from 'jwt-decode'
import { SessionTokenProps } from '../../interfaces/session'

export default (token: string): boolean => {
  const decoded = jwtDecode<SessionTokenProps>(token)
  return new Date().getTime() > decoded.exp * 1000
}
